import { Card, CardContent, Typography } from "@mui/material";
import { StatiscticCardProps } from "./types";

const StatisticCard: React.FC<StatiscticCardProps> = ({title, value, color}) => {
    return (
        <Card style={{borderBottom: `4px ${color} solid` }}>
            <CardContent sx={{ height: '100%' }}>
              <Typography variant="subtitle2" color="text.secondary">
                {title}
              </Typography>
              <Typography variant="h6" color={color} textAlign={"center"}>
                {value}
              </Typography>
            </CardContent>
        </Card>
    )
}

export default StatisticCard;